module.exports = __webpack_public_path__ + "img/form-success.262a9df1.png";